import { Hamburger } from './hamburger'

export default Hamburger
